import { Link } from 'react-router-dom'
import styled from 'styled-components'

import colors from 'styles/colors'

export const StyledCard = styled.div`
    display: flex;
    height: 10rem;
    padding: 1rem;
    background: ${colors.white89deg};
    box-shadow: ${colors.shadowBlack};
    border-radius: 2rem;
    margin-bottom: 1rem;
    position: relative;
`

export const StyledLink = styled(Link)`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
`

export const StyledImage = styled.div`
    flex: 1;
    position: relative;
    padding-top:1rem;
    border-radius: 1rem;
    background-size: cover;
    background-position: center;
`
export const StyledDate = styled.span`
    background: rgba(0, 0, 0, 0.1);
    border-radius: 0.4rem;
    color: ${colors.white};
    font-size: 1.2rem;
    line-height: 1.8rem;
    position: absolute;
    bottom: 0;
    left: 1rem;
    padding: 0.4rem;
    text-align: center;
`

export const StyledCardInfo = styled.div`
    flex: 2;
`
export const StyledCardTitle = styled.span`
    color: ${colors.blueDark};
    display: block;
    font-size: 1.4rem;
    padding-top:1rem;
    line-height: 1.6rem;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
`
